import {
  InMemoryHeader,
  InMemoryString,
  InMemoryDecimal
} from "pbas-vue-components";


function getHeaders() {
  const headers = [
    new InMemoryHeader({
      type: new InMemoryString("Identifier"),
      visible: false,
      isIdentifier: true,
      allowVisibilityChange: false,
    }),
    new InMemoryHeader({
      type: new InMemoryString("Id"),
      visible: false,
      isIdentifier: true,
      allowVisibilityChange: false,
    }),
    new InMemoryHeader({
      title: "headers.claim_submissions.plan_number",
      type: new InMemoryString("PlanNumber"),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }),
    new InMemoryHeader({
      title: "components.portal.demo_benefit_cards.width",
      type: new InMemoryDecimal("Width"),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }),
    new InMemoryHeader({
      title: "headers.dashboard_items.height",
      type: new InMemoryDecimal("Height"),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }),
    new InMemoryHeader({
      title: "globals.name",
      type: new InMemoryString("Name"),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }),
    new InMemoryHeader({
      title: "components.portal.demo_benefit_cards.source",
      type: new InMemoryString("Source"),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }),
    new InMemoryHeader({
      title: "globals.language",
      type: new InMemoryString("Language"),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    })
  ]
  return headers;
}
export default getHeaders;
